// extracted by mini-css-extract-plugin
module.exports = {"list":"ItemList_list__5r6fv"};